/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { SessionReferencesCountsDto } from './session-references-counts-dto';
 /**
 *
 *
 * @export
 * @interface WeightReferencesDto
 */
export interface WeightReferencesDto {

    /**
     * Scheduled events a propagation could still rewrite
     *
     * @type {SessionReferencesCountsDto}
     * @memberof WeightReferencesDto
     */
    updatable: SessionReferencesCountsDto;

    /**
     * Events already started or resolved. Shown so it is clear the edit is not retroactive.
     *
     * @type {SessionReferencesCountsDto}
     * @memberof WeightReferencesDto
     */
    frozen: SessionReferencesCountsDto;
}
